export default function eventTrack(a, b, c) {
  if (
    process.env.NODE_ENV === `production` &&
    typeof window.plausible === `function`
  ) {
    window.plausible(a, b, c);
  }
}
